import appStore from '@stores/appStore'

/**
 * The zone label the app's lists show after an appointment - "(AEDT, Sydney)" - for the
 * Assistant's date tokens that carry a zone (see AssistantDateOptions.zoneLabel).
 */
export const assistantZoneLabel = (instant: string, timeZone: string) =>
  appStore.getTimeZoneDisplayName(instant, timeZone)
